import initMap from './map.js';
import filterRecipes from './filter.js';
import {scrollTo} from './menu';

ymaps.ready(initMap);

filterRecipes('all', 'data-type', 'data-filter');

scrollTo();

/*
  Slider
*/

$('.hero-slider').slick({
  dots: true,
  arrows: false,
  slideToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: false
});

$('[dir="rtl"] .hero-slider').slick('slickSetOption', 'rtl', true);

/*
  Popup
*/

$('.link-to-article').magnificPopup({
  type: 'ajax'
});
